import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import { connect } from 'react-redux'

import Hexapod from '../../../Assets/images/Create Actions/Hexapod.png'
import createStyle from './ActionsCreate.module.css'
import humanoid from '../../../Assets/images/ZingImage.png'
import inactiveBtnOne from '../../../Assets/images/Create Actions/Component 31 – 71.png'
import activeBtnOne from '../../../Assets/images/Create Actions/Component 31 – 88.png'
import inactivebtntwo from '../../../Assets/images/Create Actions/Component 31 – 72.png'
import activeBtnTwo from '../../../Assets/images/Create Actions/Component 31 – 89.png'
import inactiveBtnThree from '../../../Assets/images/Create Actions/Component 31 – 3.png'
import activeBtnthree from '../../../Assets/images/Create Actions/activecomponent 31 – 90.png'
import inactivebtnfour from '../../../Assets/images/Create Actions/Component 31 – 74.png'
import activeBtnfour from '../../../Assets/images/Create Actions/Component 31 – 91.png'
import inactiveBtnfive from '../../../Assets/images/Create Actions/Component 31 – 75.png'
import activeBtnfive from '../../../Assets/images/Create Actions/Component 31 – 92.png'
import inactiveBtnsix from '../../../Assets/images/Create Actions/Component 31 – 76.png'
import activeBtnsix from '../../../Assets/images/Create Actions/Component 31 – 93.png'
import inactiveBtnseven from '../../../Assets/images/Create Actions/Component 31 – 77.png'
import activeBtnseven from '../../../Assets/images/Create Actions/Component 31 – 94.png'
import inactivebtneight from '../../../Assets/images/Create Actions/Component 31 – 78.png'
import activeBtneight from '../../../Assets/images/Create Actions/Component 31 – 95.png'
import inactivebtnnine from '../../../Assets/images/Create Actions/Component 31 – 79.png'
import activeBtnnine from '../../../Assets/images/Create Actions/Component 31 – 96.png'
import inactivebtnten from '../../../Assets/images/Create Actions/Component 31 – 80.png'
import activeBtnten from '../../../Assets/images/Create Actions/Component 31 – 97.png'
import inactivebtneleven from '../../../Assets/images/Create Actions/Component 31 – 81.png'
import activeBtneleven from '../../../Assets/images/Create Actions/Component 31 – 98.png'
import inactivebtntweleve from '../../../Assets/images/Create Actions/Component 31 – 82.png'
import activeBtnTweleve from '../../../Assets/images/Create Actions/Component 31 – 99.png'
import inactiveBtnthirteen from '../../../Assets/images/Create Actions/Component 31 – 83.png'
import activeBtnThirteen from '../../../Assets/images/Create Actions/Component 31 – 100.png'
import inactiveBtnfourteen from '../../../Assets/images/Create Actions/Component 31 – 67.png'
import activeBtnfourteen from '../../../Assets/images/Create Actions/Component 31 – 84.png'
import inactiveBtnfifteen from '../../../Assets/images/Create Actions/Component 31 – 68.png'
import activeBtnfifteen from '../../../Assets/images/Create Actions/Component 31 – 85.png'
import inactiveBtnsixteen from '../../../Assets/images/Create Actions/Component 31 – 69.png'
import activeBtnsixteen from '../../../Assets/images/Create Actions/Component 31 – 86.png'
import inactiveBtnseventeen from '../../../Assets/images/Create Actions/Component 31 - 101.png'
import activeBtnseventeen from '../../../Assets/images/Create Actions/Component 31 - 103.png'
import inactiveBtneightteen from '../../../Assets/images/Create Actions/Component 31 - 102.png'
import activeBtneightteen from '../../../Assets/images/Create Actions/Component 31 - 104.png'
import inactiveBtnH from '../../../Assets/images/Create Actions/Component 31 – 70.png'
import activeBtnH from '../../../Assets/images/Create Actions/Component 31 – 87.png'
import backbutton from '../../../Assets/images/back@2x.png'
import nextbutton from '../../../Assets/images/next@2x.png'
import loaderStyle from './ViewActions.module.css'

import renderPrgImage from '../../../source/programImg'
import ProgramHeader from '../../ReusableComponents/Header/ProgramHeader'
import { readBytes, sendBytes } from '../../ReusableComponents/ByteTransfer'
import unicodeToChar from '../../../utils/unicodeToChar'
import SavePopUp from './SavePopUp'
import ViewActions from './ViewActions'
import {
    CREATEACTIONSTATE,
    DEFAULTSERVOVALUES,
    SINGLEACTIONSTATE,
    MINARRAYFORZINGACTION,
    MAXARRAYFORZINGACTION,
    MINARRAYFORHEXAPODACTION,
    MAXARRAYFORHEXAPODACTION,
} from './defaultData'
import SliderBox from '../../ReusableComponents/SliderBox/SliderBox'

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import ActionButton from './ActionButton'
import {
    actionConverter,
    decimalToMSBLSB,
    generateDeviceDataKey,
    MSBLSBToDecimal,
} from '../../ReusableComponents/ByteTransfer/utils'
import { Block } from '@material-ui/icons'
import { style } from '@material-ui/system'
import DialogModal from '../../ReusableComponents/DialogModal/DialogModal'
import ActionCreateHelp from './ActionsCreateHelp'
import ActionCreateNew from './newCreateActionComponents/ActionCreateNew'
import ServoDetailsPopup from './newCreateActionComponents/ServoDetailsPopup'
import TimeEditPopup from './newCreateActionComponents/TimeEditPopup'
import renderImage from '../../../source/importImg'
import DeviceMotorIdImg from './newCreateActionComponents/DeviceMotorIdImg'
import { useIndexedDB } from 'react-indexed-db'
import {
    calculateWaitTime,
    checkFileExist,
    getMountPoint,
    writeFile,
} from '../../../utils/readWriteFile'
import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions'

// import { generateDeviceDataKey } from '../../Humanoid/defaultData'

const regions = RegionsPlugin.create({})

const connectedDevice = sessionStorage.getItem('connectedDevice')
let status = true
const addIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        fill="currentColor"
        className="bi bi-plus-circle-dotted"
        viewBox="0 0 16 16"
    >
        <path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
    </svg>
)
const IMAGE = {
    HEXAPOD: Hexapod,
    HUMANOID: humanoid,
}

//
//    ACTIONS TO BYTE
//    The function acts like a adapter that converts the custom servo values into bytes
//    that can be readily sent to the humanoid
//
export const actionsToBytes = ({
    actionsData,
    AGSlotId,
    mode,
    SingleAction,
    fileName,
    isShowNewUI,
}) => {
    console.log(actionsData, AGSlotId, mode, SingleAction)
    const actionGroupBytes = []
    let waitTime = 2000
    let actionDetailsObj = {
        projectName: '',
        actionDetails: [],
    }
    let actionDetails = []
    let generateBytesStatus = true
    const connectedDevice = sessionStorage.getItem('connectedDevice') || ''
    const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'

    const servoDataKey = generateDeviceDataKey(connectedDevice, deviceVersion)
    // Now each actionArr will look like this : ['T', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 'H']
    const actionArr = Array.from(
        { length: connectedDevice === 'Hexapod' ? 18 : 16 },
        (_, i) => i + 1
    )
    if (connectedDevice === 'Humanoid') {
        actionArr.push('H')
    }
    actionArr.splice(0, 0, 'T')

    // Prefix Flag for single action group only for v1 and v2
    if (
        ['1', '2', '3'].includes(deviceVersion[0]) &&
        ['Humanoid', 'Hexapod'].includes(connectedDevice) &&
        (!isShowNewUI || (isShowNewUI && !fileName))
    ) {
        let fLength
        let fNameAsci = []
        if (fileName) {
            // fileName = fileName + '.BIN'
            fLength = fileName.length

            fNameAsci = fileName.split('').map((char) => char.charCodeAt(0))
            console.log('KKKKKKKKKKKK', fNameAsci)
        }
        actionGroupBytes.push(
            'G'.charCodeAt(0),
            'R'.charCodeAt(0)
            // 123,
            // 125,
            // 'N'.charCodeAt(0),
            // 123
        )
        if (fileName) {
            actionGroupBytes.push(fLength, ...fNameAsci)
        } else {
            actionGroupBytes.push(0)
        }
    }

    // Looping over all actions
    // Exporting all the actions in the action group
    if (mode == 'ALLACTIONS') {
        if (
            ['1', '2', '3'].includes(deviceVersion[0]) &&
            ['Humanoid', 'Hexapod'].includes(connectedDevice)
        ) {
            let MSBLSBRowLength = decimalToMSBLSB(actionsData.allActions.length)
            actionGroupBytes.push(
                MSBLSBRowLength[0],
                MSBLSBRowLength[1]
                // 125
                // 'P'.charCodeAt(0)
            )
        }
        actionsData.allActions.map((action) => {
            // Prefix Flag for single action group
            if (
                !(
                    ['1', '2', '3'].includes(deviceVersion[0]) &&
                    ['Humanoid', 'Hexapod'].includes(connectedDevice)
                )
            ) {
                actionGroupBytes.push(
                    'A'.charCodeAt(0),
                    'G'.charCodeAt(0),
                    AGSlotId,
                    actionsData.allActions.length
                )
            }

            if (isShowNewUI && action.actionName) {
                actionDetails.push({ actionName: action.actionName })
            }

            //calculate the total time require to complete the all action
            waitTime += action.data['T'].value

            //if the each action process time more than 5000 mili Secode or
            //less than 100 mili second then not excute the action
            // if (action.data['T'].value > 5000 || action.data['T'].value < 100) {
            //     generateBytesStatus = false
            // }

            // Filling each servo value for particular action
            actionArr.map((key) => {
                let MSBLSB
                if (key !== 'H') {
                    if (action.data[key].isEnabled || isShowNewUI)
                        MSBLSB = decimalToMSBLSB(action.data[key].value)
                    else
                        MSBLSB = decimalToMSBLSB(
                            DEFAULTSERVOVALUES[
                                servoDataKey
                                // `${connectedDevice.toUpperCase()}`
                            ][key]
                        )
                    actionGroupBytes.push(MSBLSB[0], MSBLSB[1])
                } else {
                    if (
                        !(
                            ['1', '2', '3'].includes(deviceVersion[0]) &&
                            ['Humanoid', 'Hexapod'].includes(connectedDevice)
                        )
                    ) {
                        if (action.data[key].isEnabled)
                            actionGroupBytes.push(action.data[key].speed)
                        else actionGroupBytes.push(10)

                        // if (action.data[key].isEnabled)
                        //     actionGroupBytes.push(action.data[key].value)
                        // else actionGroupBytes.push(90)
                    }

                    if (action.data[key].isEnabled || isShowNewUI)
                        actionGroupBytes.push(action.data[key].value)
                    else actionGroupBytes.push(90)
                }
            })

            // Suffix Flag for single action group
            if (
                ['1', '2', '3'].includes(deviceVersion[0]) &&
                ['Humanoid', 'Hexapod'].includes(connectedDevice)
            ) {
                // actionGroupBytes.push(125) //'E'.charCodeAt(0), 'R'.charCodeAt(0)
            } else {
                actionGroupBytes.push(
                    'X'.charCodeAt(0),
                    'Y'.charCodeAt(0),
                    'Z'.charCodeAt(0)
                )
            }
        })
        if (
            ['1', '2', '3'].includes(deviceVersion[0]) &&
            ['Humanoid', 'Hexapod'].includes(connectedDevice)
        ) {
            actionGroupBytes.push('E'.charCodeAt(0), 'R'.charCodeAt(0))
        }

        // Exporting only one action in the entire action group
    } else if (mode == 'ONLYTHISACTION') {
        // Prefix Flag for single action group
        if (
            ['1', '2', '3'].includes(deviceVersion[0]) &&
            ['Humanoid', 'Hexapod'].includes(connectedDevice)
        ) {
            let MSBLSBRowLength = decimalToMSBLSB(1)
            actionGroupBytes.push(
                MSBLSBRowLength[0],
                MSBLSBRowLength[1]
                // 125,
                // 'P'.charCodeAt(0),
                // 123
            )
        } else {
            actionGroupBytes.push(
                'A'.charCodeAt(0),
                'G'.charCodeAt(0),
                AGSlotId,
                0
            )
        }
        const action = SingleAction
        if (!action) {
            return {
                data: null,
                waitTime: 2000,
                status: false,
                actionDetailsObj,
            }
        }
        //calculate the total time for wait
        waitTime += action.data['T'].value

        //if the each action process time more than 5000 mili Secode or
        //less than 100 mili second then not excute the action
        // if (action.data['T'].value > 5000 || action.data['T'].value < 100) {
        //     return {
        //         data: null,
        //         waitTime: 2000,
        //         status: false,
        //         actionDetailsObj,
        //     }
        // }

        actionArr.map((key) => {
            let MSBLSB
            if (key !== 'H') {
                if (action.data[key].isEnabled || isShowNewUI) {
                    MSBLSB = decimalToMSBLSB(action.data[key].value)
                } else {
                    MSBLSB = decimalToMSBLSB(
                        DEFAULTSERVOVALUES[servoDataKey][key]
                    )
                }
                actionGroupBytes.push(MSBLSB[0], MSBLSB[1])
            } else {
                if (
                    !(
                        ['1', '2', '3'].includes(deviceVersion[0]) &&
                        ['Humanoid', 'Hexapod'].includes(connectedDevice)
                    )
                ) {
                    if (action.data[key].isEnabled)
                        actionGroupBytes.push(action.data[key].speed)
                    else actionGroupBytes.push(10)

                    if (action.data[key].isEnabled)
                        actionGroupBytes.push(action.data[key].value)
                    else actionGroupBytes.push(90)
                }

                if (action.data[key].isEnabled || isShowNewUI)
                    actionGroupBytes.push(action.data[key].value)
                else actionGroupBytes.push(90)
            }
        })

        // Suffix Flag for single action group
        if (
            ['1', '2', '3'].includes(deviceVersion[0]) &&
            ['Humanoid', 'Hexapod'].includes(connectedDevice)
        ) {
            actionGroupBytes.push('E'.charCodeAt(0), 'R'.charCodeAt(0))
        } else {
            actionGroupBytes.push(
                'X'.charCodeAt(0),
                'Y'.charCodeAt(0),
                'Z'.charCodeAt(0)
            )
        }
    }
    if (!generateBytesStatus) {
        return {
            data: null,
            waitTime: 2000,
            status: false,
            actionDetailsObj,
        }
    }
    actionDetailsObj.projectName = fileName
    actionDetailsObj.actionDetails = actionDetails
    return {
        data: actionGroupBytes,
        waitTime: waitTime,
        status: true,
        actionDetailsObj,
    }
}

function CreateAction({
    webSerial,
    worker,
    device,
    socketData,
    deviceMismatch,
}) {
    const history = useHistory()
    const { getAll, clear } = useIndexedDB('AudioFiles')
    const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
    const isShowNewUI = JSON.parse(
        sessionStorage.getItem('isShowNewUI') || 'false'
    )
    //deviceVersion.startsWith('2')
    const isZingVersion12 =
        ['1', '2'].includes(
            (sessionStorage.getItem('deviceVersion') || '0.0.0')[0]
        ) && ['Humanoid'].includes(sessionStorage.getItem('connectedDevice'))

    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const [createActionState, setCreateActionState] = useState(() => {
        if (isShowNewUI) {
            let newState = JSON.parse(JSON.stringify(CREATEACTIONSTATE))
            newState.allActions = []
            return newState
        }
        return JSON.parse(JSON.stringify(CREATEACTIONSTATE))
    }) //isShowNewUI ? null :
    const [selectedAction, setSelectedAction] = useState(0)
    const [showPrimaryButtons, setShowPrimaryButtons] = useState(false)
    const [hoverActionId, setHoverActionId] = useState(0)
    const [display, setDisplay] = useState('block')
    const [filePopup, setFilePopUp] = useState(false)
    const [retrieveActions, setRetrieveActions] = useState(false)
    const [showDeviceConnectModal, setShowDeviceConnectModal] = useState({
        isShow: false,
        text: '',
    })
    const [slideDirection, setSlideDirection] = useState(
        sessionStorage.getItem('slideDirection')
    )
    const [showHelpScreen, setShowHelpScreen] = useState(false)
    // const [isAudioEnable, setIsAudioEnablen] = useState(true)
    const [showErasModal, setShowErasModal] = useState(false)
    const [showDeviceModal, setShowDeviceModal] = useState(false)
    const [showTimeInputModal, setShowTimeInputModal] = useState(false)
    const [audioFile, setAudioFile] = useState(null)
    const [projectName, setProjectName] = useState('')
    const [isMotorTorqueEnable, setIsMotorTorqueEnable] = useState(false)
    const [servoDetailsPopUpObj, setServoDetailsPopUpObj] = useState({
        isShowsServoDetailsPopUp: false,
        servoId: 1,
        actionNumber: 0,
    })
    const [timeEditPopUp, setTimeEditPopUp] = useState({
        isShow: false,
        actionNumber: 0,
    })
    const sendDataRef = useRef({ sendDataAsPacket: false, readVal: '' })
    const sendDataWaitTimeRef = null
    const tableBodyRef = useRef(null)
    const waveSurferRef = useRef(null)
    const isNotReadRef = useRef(true)
    const timeInputRef = useRef(null)
    const portalPopupRef = useRef(null)
    const timeOutRef = useRef(null)
    const playPauseRef = useRef(false)

    const COMMONBUTTONS = [
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-one-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[1]?.isSelected
                    ? activeBtnOne
                    : inactiveBtnOne
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-two-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[2]?.isSelected
                    ? activeBtnTwo
                    : inactivebtntwo
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-three-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[3]?.isSelected
                    ? activeBtnthree
                    : inactiveBtnThree
            }
        />,

        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-four-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[4]?.isSelected
                    ? activeBtnfour
                    : inactivebtnfour
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-five-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[5]?.isSelected
                    ? activeBtnfive
                    : inactiveBtnfive
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-six-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[6]?.isSelected
                    ? activeBtnsix
                    : inactiveBtnsix
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-seven-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[7]?.isSelected
                    ? activeBtnseven
                    : inactiveBtnseven
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-eight-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[8]?.isSelected
                    ? activeBtneight
                    : inactivebtneight
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-nine-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[9]?.isSelected
                    ? activeBtnnine
                    : inactivebtnnine
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-ten-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[10]?.isSelected
                    ? activeBtnten
                    : inactivebtnten
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-eleven-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[11]?.isSelected
                    ? activeBtneleven
                    : inactivebtneleven
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-tweleve-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[12]?.isSelected
                    ? activeBtnTweleve
                    : inactivebtntweleve
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-thirteen-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[13]?.isSelected
                    ? activeBtnThirteen
                    : inactiveBtnthirteen
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-fourteen-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[14]?.isSelected
                    ? activeBtnfourteen
                    : inactiveBtnfourteen
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-fifteen-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[15]?.isSelected
                    ? activeBtnfifteen
                    : inactiveBtnfifteen
            }
        />,
        <img
            className={`${createStyle['sc-toggle-button']} ${
                createStyle[
                    `sc-btn-${connectedDevice.toLowerCase()}-sixteen-${isShowNewUI}`
                ]
            }`}
            src={
                createActionState?.commonActionState?.[16]?.isSelected
                    ? activeBtnsixteen
                    : inactiveBtnsixteen
            }
        />,
    ]
    const DEVICEBUTTONS = {
        HUMANOID: COMMONBUTTONS,
        HEXAPOD: COMMONBUTTONS,
        KLAW: [COMMONBUTTONS.slice(0, 5)],
    }

    const handleClickHelpBtn = () => {
        setShowHelpScreen(true)
    }
    const closeHelpScreen = () => {
        setShowHelpScreen(false)
    }
    // loading existing createActionState or loading a new one
    useEffect(() => {
        sessionStorage.setItem('isSave', JSON.stringify(true))

        const getIntialData = async () => {
            const existingState = JSON.parse(
                sessionStorage.getItem('createActionState')
            )
            if (
                JSON.parse(
                    sessionStorage.getItem('actionFileOpen') || 'false'
                ) ||
                !JSON.parse(sessionStorage.getItem('isShowNewUI') || 'false')
            ) {
                sessionStorage.setItem('actionFileOpen', 'false')
                let existingAudioFile = await getAll()
                if (existingAudioFile.length > 0)
                    setAudioFile(existingAudioFile?.[0]?.fileData)

                if (existingState) {
                    if (!existingState.projectName)
                        existingState.projectName = 'Name'
                    setCreateActionState(existingState)
                }
                // if (
                //     existingState &&
                //     existingState.allActions.length > 0 &&
                //     !existingAudioFile.length > 0
                // ) {
                //     setIsAudioEnablen(false)
                // }
            } else {
                console.log('HHHHHHHHH')
                // if (existingState && !isShowNewUI) {
                //     setCreateActionState(existingState)
                // }
                await clear()
            }
            // getAll().then((result) => {
            //     console.log('MMMMMMM', result)
            // })

            // if (existingState && !isShowNewUI) {
            //     // if (!existingState.projectName)
            //     //     existingState.projectName = 'Name'
            //     setCreateActionState(existingState)
            // }
            // await clear()
            // if (
            //     existingState &&
            //     existingState.allActions.length > 0 &&
            //     !existingAudioFile.length > 0
            // ) {
            //     setIsAudioEnablen(false)
            // }
            // sending bytes to stop standby actions
            // sendBytes(
            //     ['S'.charCodeAt(0), 'A'.charCodeAt(0), 'E'.charCodeAt(0)],
            //     webSerial.port
            // )
        }

        getIntialData()
    }, [])

    // Saving each change directly to the sessionStorage
    useEffect(() => {
        sessionStorage.setItem(
            'createActionState',
            JSON.stringify(createActionState)
        )
    })

    const [lastSentBytesTime, setLastSentBytesTime] = useState(Date.now())

    // This function sends servo bytes instantly to get the live feedback
    const liveServoFeedback = (servoId, value) => {
        if (retrieveActions) return
        if (display === 'none') return
        if (servoId === 'T') return

        const servoFeedbackBytes = []
        if (servoId === 'H' || servoId === 'Hservo') {
            servoFeedbackBytes.push('S'.charCodeAt(0), 'M'.charCodeAt(0), 17)
        } else {
            servoFeedbackBytes.push(
                'S'.charCodeAt(0),
                'M'.charCodeAt(0),
                parseInt(servoId)
            )
        }

        let MSBLSB = decimalToMSBLSB(value)
        servoFeedbackBytes.push(MSBLSB[0], MSBLSB[1])

        // sends bytes every 100ms
        // Zing doesn't respond when sent faster than 100ms
        const now = Date.now()
        if (now - lastSentBytesTime < 100) return
        console.log(servoFeedbackBytes)
        // if (deviceVersion?.startsWith('2')) {
        worker.postMessage({
            type: 'writeArray',
            value: servoFeedbackBytes,
        })
        // } else {
        //     sendBytes(servoFeedbackBytes, webSerial.port)
        // }
        setLastSentBytesTime(now)
    }

    // changes to determine Min and Max value for Zing motors
    const handleMinMax = (servoId, tag, device) => {
        if (device === 'ZING') {
            if (tag === 'MIN') {
                return (
                    MINARRAYFORZINGACTION[servoId - 1] ||
                    (deviceVersion?.[0] === '2' ? 1 : 0)
                )
            } else {
                return MAXARRAYFORZINGACTION[servoId - 1]
            }
        } //We can add more devices here
        if (device === 'HEXAPOD') {
            if (tag === 'MIN') {
                return MINARRAYFORHEXAPODACTION[servoId - 1]
            } else {
                return MAXARRAYFORHEXAPODACTION[servoId - 1]
            }
        }
    }

    // resolves the valid min/max range for a given servo/time key
    const getServoMinMax = (servoId) => {
        let min = 0
        let max = 1000
        if (servoId === 'T') {
            max = 5000
        } else if (servoId === 'H') {
            max = 180
        } else if (connectedDevice === 'Hexapod') {
            min = handleMinMax(servoId, 'MIN', 'HEXAPOD')
            max = handleMinMax(servoId, 'MAX', 'HEXAPOD')
        } else if (isZingVersion12) {
            min = handleMinMax(servoId, 'MIN', 'ZING')
            max = handleMinMax(servoId, 'MAX', 'ZING')
        }
        return { min, max }
    }

    // edits a value (time or servo) of any action directly from the table,
    // keeping the value within its valid range
    const handleActionDataChange = (actionNumber, key, value) => {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        const { min, max } = getServoMinMax(key)
        let newValue = parseInt(value)
        if (isNaN(newValue)) newValue = min
        if (newValue < min) newValue = min
        else if (newValue > max) newValue = max

        const newCreateActionState = { ...createActionState }
        let cumulativeTime = 0
        newCreateActionState.allActions = createActionState.allActions.map(
            (action, index) => {
                if (index === actionNumber) {
                    action.data[key].value = newValue
                }
                // editing the time shifts this marker and every following one
                if (key === 'T') {
                    cumulativeTime += action.data['T'].value
                    action.markerPositionTime = (
                        cumulativeTime / 1000
                    ).toFixed(3)
                }
                return action
            }
        )
        setCreateActionState(newCreateActionState)

        // keep the waveform markers in sync when an audio file is loaded
        if (key === 'T' && waveSurferRef.current) {
            const allRegions = regions.getRegions()
            newCreateActionState.allActions.forEach((action) => {
                const region = allRegions.find((ele) => ele.id === action.id)
                if (region) {
                    region.setOptions({
                        start: Number(action.markerPositionTime),
                        content: `${action.markerPositionTime}`,
                    })
                }
            })
        }

        if (actionNumber === selectedAction) {
            liveServoFeedback(key, newValue)
        }
    }

    // changes servo values
    const handleSliderChange = (servoId, value) => {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        const newCreateActionState = { ...createActionState }
        newCreateActionState.allActions = createActionState.allActions.map(
            (action, index) => {
                if (index != selectedAction) return action
                if (['Hspeed', 'Hservo'].includes(servoId)) {
                    if (servoId === 'Hspeed') {
                        action.data['H'].speed = value
                        return action
                    } else {
                        action.data['H'].value = value
                        return action
                    }
                } else {
                    action.data[servoId].value = value
                    return action
                }
            }
        )
        setCreateActionState(newCreateActionState)
        liveServoFeedback(servoId, value)
    }

    // Enables/disables servos
    const handleSliderBtnClick = (servoId) => {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        if (['Hspeed', 'Hservo'].includes(servoId)) servoId = 'H'
        const newCreateActionState = { ...createActionState }
        newCreateActionState.allActions = createActionState.allActions.map(
            (action, index) => {
                if (index != selectedAction) return action
                action.data[servoId].isEnabled = !action.data[servoId].isEnabled
                if (action.data[servoId].isEnabled) {
                    liveServoFeedback(servoId, action.data[servoId].value)
                } else {
                    const servoDataKey = generateDeviceDataKey(
                        connectedDevice,
                        deviceVersion
                    )
                    let defaultServoValue =
                        DEFAULTSERVOVALUES?.[servoDataKey]?.[servoId]
                    liveServoFeedback(servoId, defaultServoValue)
                    action.data[servoId].value = defaultServoValue
                }
                return action
            }
        )
        setCreateActionState(newCreateActionState)
    }

    // Changes the focus of currently selected action amoung the action group.
    const handleSelectAction = (id) => {
        setSelectedAction(id)
        setShowPrimaryButtons(true)
    }

    // shows the delete and copy option when hovered over any of the action button
    const handleToggleButtons = (id, condition) => {
        // if (id !== selectedAction) return
        setHoverActionId(id)
        setShowPrimaryButtons(condition)
    }

    //sort the action accroding to thear markers time
    function sortMarkersByTime(newMarkers) {
        newMarkers.sort((a, b) => a.markerPositionTime - b.markerPositionTime)
        return newMarkers
    }

    //calculate the each action  required time to complited
    const calculateActionRunTime = ({
        allActions,
        id,
        markerPositionTime = 0,
    }) => {
        try {
            // console.log('XXXXXXXXX111', allActions, id, markerPositionTime)
            let previousMarkerPositionTime = 0

            const index = allActions.findIndex((item) => item.id === id)
            if (index > 0) {
                previousMarkerPositionTime =
                    allActions[index - 1]?.markerPositionTime
            }
            if (index < allActions.length - 1) {
                let nextMarkerPositionTime =
                    allActions[index + 1]?.markerPositionTime
                allActions[index + 1].data.T.value =
                    (nextMarkerPositionTime - markerPositionTime).toFixed(3) *
                    1000
            }

            let time =
                (markerPositionTime - previousMarkerPositionTime).toFixed(3) *
                1000
            return { time, index }
        } catch (e) {
            console.log(e)
            return {}
        }
    }

    //update the action time when drag any marker
    // updated by the id of the action
    function updateMarkerById(id, newTime) {
        try {
            const generatNewAllaction = (createActionState, id, newTime) => {
                sessionStorage.setItem('isSave', JSON.stringify(false))
                const newCreateActionState = { ...createActionState }
                const newaction = newCreateActionState.allActions.find(
                    (action) => action.id === id
                )
                if (newaction) {
                    newaction.markerPositionTime = newTime
                }
                newCreateActionState.allActions = sortMarkersByTime(
                    newCreateActionState.allActions
                )

                const { time, index } = calculateActionRunTime({
                    allActions: newCreateActionState.allActions,
                    id,
                    markerPositionTime: newTime,
                })

                newaction.data.T.value = time
                return newCreateActionState
            }

            setCreateActionState((prev) =>
                generatNewAllaction(prev, id, newTime)
            )
        } catch (e) {
            console.error(e)
        }
    }

    const getAllNewAction = (
        createActionState,
        id,
        markerPositionTime = 0,
        withOutAudio,
        inputTime
    ) => {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        const newCreateActionState = { ...createActionState }
        let singleActionDataState = JSON.parse(
            JSON.stringify(SINGLEACTIONSTATE)
        )
        Object.keys(singleActionDataState).map((eleKey) => {
            singleActionDataState[eleKey].isEnabled = true
        })

        let newActionData = {
            id: id || Math.random().toString(16).slice(2, 6),
            data: singleActionDataState,
            markerPositionTime,
            actionName: '',
        }

        //edit here to get more actions
        newCreateActionState.allActions.push(newActionData)

        // if (isShowNewUI && isAudioEnable) {
        if (!withOutAudio) {
            newCreateActionState.allActions = sortMarkersByTime(
                newCreateActionState.allActions
            )
            const { time, index } = calculateActionRunTime({
                allActions: newCreateActionState.allActions,
                id,
                markerPositionTime,
            })
            newActionData.data.T.value = time
            // newActionData.actionName = 'Action ' + (index + 1)

            //get the uniq action anme
            let actionNumber = 0
            newCreateActionState.allActions.forEach((eachAction, ind) => {
                if (eachAction?.actionName?.includes('Action')) {
                    let num = parseInt(
                        eachAction?.actionName?.split(' ')[1] || '0'
                    )
                    actionNumber = num > actionNumber ? num : actionNumber
                }
            })
            newActionData.actionName = 'Action ' + (actionNumber + 1)
        } else {
            let totalTime = 0
            newCreateActionState?.allActions?.map((ele, ind) => {
                totalTime += ele.data.T.value
            })
            totalTime -= 1000
            totalTime += inputTime
            totalTime = (Number(totalTime) / 1000).toFixed(3)
            newActionData.data.T.value = inputTime
            newActionData.actionName =
                'Action ' + newCreateActionState.allActions.length
            newActionData.markerPositionTime = totalTime
        }

        return newCreateActionState
    }

    const addNewAction = ({
        id,
        markerPositionTime = 0,
        withOutAudio,
        inputTime,
    }) => {
        if (isShowNewUI) {
            setCreateActionState((prev) =>
                getAllNewAction(
                    prev,
                    id,
                    markerPositionTime,
                    withOutAudio,
                    inputTime
                )
            )
        }
        if (!isShowNewUI) {
            sessionStorage.setItem('isSave', JSON.stringify(false))
            const newCreateActionState = { ...createActionState }
            //edit here to get more actions
            newCreateActionState.allActions.push({
                id: Math.random().toString(16).slice(2, 6),
                data: JSON.parse(JSON.stringify(SINGLEACTIONSTATE)),
            })
            setCreateActionState(newCreateActionState)
            setTimeout(() => {
                const lastActionId = createActionState.allActions.length
                const element = document.getElementById(
                    `actionBtn-${lastActionId}`
                )
                element.scrollIntoView()
            }, 100)
        }
    }

    const handelAddNewAction = ({ inputTime }) => {
        // let time = (Number(inputTime) / 1000).toFixed(3)
        if (waveSurferRef.current) {
            const newCreateActionState = { ...createActionState }
            let totalTime = 0
            newCreateActionState?.allActions?.map((ele, ind) => {
                totalTime += ele.data.T.value
            })
            totalTime = totalTime + Number(inputTime)
            totalTime = (Number(totalTime) / 1000).toFixed(3)

            const audioDuration = (
                waveSurferRef.current.getDuration() - 0.05
            )?.toFixed(3)
            if (audioDuration < Number(totalTime)) {
                setShowDeviceConnectModal({
                    isShow: true,
                    text: `Please enter a time less than the audio time duration. The audio time duration is ${
                        audioDuration * 1000
                    } millisecond.`,
                })
                return
            }

            let region1 = regions.addRegion({
                start: Number(totalTime),
                content: `${Number(totalTime)}`,
                color: 'rgba(255, 0, 0, 0.5)',
            })
            addNewAction({
                markerPositionTime: region1.start.toFixed(3),
                id: region1.id,
            })
            setTimeout(() => {
                waveSurferRef.current.seekTo(
                    region1.start / waveSurferRef.current.getDuration()
                )
            }, 100) // 100ms delay
        } else {
            addNewAction({
                withOutAudio: true,
                inputTime: Number(inputTime),
            })
        }
    }

    const handelSubmitTimeInput = () => {
        if (timeInputRef.current) {
            setShowTimeInputModal(false)
            handelAddNewAction({
                inputTime: timeInputRef.current.value,
            })
        }
    }

    // delete the action data from create action array.
    const deleteAction = (event, idToDel) => {
        try {
            if (!isShowNewUI) {
                event.stopPropagation()
                if (createActionState.allActions.length == 1) return
            }
            sessionStorage.setItem('isSave', JSON.stringify(false))

            if (selectedAction == createActionState.allActions.length - 1) {
                if (
                    createActionState.allActions.length == 2 ||
                    createActionState.allActions.length == 1
                ) {
                    setSelectedAction(0)
                } else {
                    setSelectedAction(Math.abs(idToDel - 1))
                }
            }
            const newCreateActionState = { ...createActionState }
            let newSelectedActionIndx = 0
            if (isShowNewUI) {
                if (
                    createActionState.allActions.length !== 2 ||
                    createActionState.allActions.length !== 1
                ) {
                    newSelectedActionIndx = Math.abs(idToDel - 1)
                }
                //set the new time for next action
                if (idToDel + 1 < newCreateActionState.allActions.length) {
                    newCreateActionState.allActions[idToDel + 1].data.T.value =
                        newCreateActionState.allActions[idToDel + 1].data.T
                            .value +
                        newCreateActionState.allActions[idToDel].data.T.value
                }
            }

            if (waveSurferRef.current) {
                if (
                    newSelectedActionIndx >= 0 &&
                    idToDel != 0 &&
                    newCreateActionState.allActions.length > 1
                ) {
                    //set the new postion of cursor in wave from
                    waveSurferRef.current.seekTo(
                        newCreateActionState.allActions[newSelectedActionIndx]
                            .markerPositionTime /
                            waveSurferRef.current.getDuration()
                    )
                } else {
                    waveSurferRef.current.seekTo(0)
                }
            }

            newCreateActionState.allActions.splice(idToDel, 1)
            setCreateActionState(newCreateActionState)
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    const copyAction = (event, idToCopy) => {
        event.stopPropagation()
        sessionStorage.setItem('isSave', JSON.stringify(false))
        const newCreateActionState = { ...createActionState }
        newCreateActionState.allActions.push({
            id: Math.random().toString(16).slice(2, 6),
            data: JSON.parse(
                JSON.stringify(createActionState.allActions[idToCopy].data)
            ),
        })
        setCreateActionState(newCreateActionState)
        setSelectedAction(newCreateActionState.allActions.length - 1)
    }

    // Sends the action bytes of only the selected action
    const handlePlayAction = async (index) => {
        if (!webSerial.isConnected) {
            setShowDeviceConnectModal({
                isShow: true,
                text: 'Please connect the device.',
            })
            return
        }
        setDisplay('none')
        const actionsData = JSON.parse(
            sessionStorage.getItem('createActionState')
        )

        const { data, waitTime, status } = await actionsToBytes({
            actionsData: actionsData,
            AGSlotId: 0,
            mode: 'ONLYTHISACTION',
            SingleAction: createActionState.allActions[index],
            fileName: '',
            isShowNewUI: isShowNewUI,
        })
        // if (!status) {
        //     alert(
        //         'The action performance time can not less than 100 millisecond or more than 5000 millisecond.'
        //     )
        //     setDisplay('block')
        //     return
        // }
        console.log('action bytes', data)
        // if (sessionStorage.getItem('deviceVersion')?.startsWith('2')) {
        // sessionStorage.setItem('setHandlePlayAction_Start', 'true')
        worker.postMessage({
            type: 'writeArray',
            value: data,
        })
        // sessionStorage.setItem('sendDataAsPacket', 'true')
        sendDataRef.current = { sendDataAsPacket: true, readVal: '' }
        try {
            let replyOK = await Promise.race([
                checkOk(),
                timeoutPromise(waitTime), //
            ])
            setDisplay('block')
        } catch (e) {
            setDisplay('block')
        }
        // } else {
        //     await sendBytes(data, webSerial.port)
        //     if (await readBytes(webSerial.port, 'OK')) setDisplay('block')
        // }
    }

    const newuiGroupActionPlay1 = async (actionsData, isplay = true) => {
        try {
            // if (actionDetailsObj?.length <= 0) {
            if (createActionState.allActions.length <= 0) {
                setShowDeviceConnectModal({
                    isShow: true,
                    text: 'Please add at least one action before playing.',
                })
                setDisplay('block')
                return
            }

            const len = createActionState.allActions.length

            const playBytesArr = []
            for (let i = 0; i < len; i++) {
                const action = createActionState.allActions[i]

                const { data, waitTime, status } = await actionsToBytes({
                    actionsData: actionsData,
                    AGSlotId: 0,
                    mode: 'ONLYTHISACTION',
                    SingleAction: action,
                    fileName: '',
                    isShowNewUI: isShowNewUI,
                })

                // if (!status) {
                //     setShowDeviceConnectModal({
                //         isShow: true,
                //         text: `Invalid marker position! Each action's completion time must be between 100ms and 5000ms.`,
                //     })
                //     setDisplay('block')
                //     return
                // }
                playBytesArr.push({ data, waitTime })
            }

            for (let i = 0; i < len; i++) {
                if (!playPauseRef.current) {
                    break
                }
                const { data, waitTime } = playBytesArr[i]

                worker.postMessage({
                    type: 'writeArray',
                    value: data,
                })
                // sessionStorage.setItem('sendDataAsPacket', 'true')
                sendDataRef.current = { sendDataAsPacket: true, readVal: '' }

                let replyOK = await Promise.race([
                    checkOk(),
                    timeoutPromise(waitTime), //
                ])
                // await new Promise((reslove) => setTimeout(reslove, 30000))
            }
            setDisplay('block')
            playPauseRef.current = false
        } catch (e) {
            setDisplay('block')
            console.log('ERROR', e)
            playPauseRef.current = false
        }
    }

    const newuiGroupActionPlay = async (actionsData, isplay = true) => {
        try {
            setShowDeviceConnectModal({
                isShow: true,
                text: 'Action saving....',
            })
            const { data, waitTime, status, actionDetailsObj } = actionsToBytes(
                {
                    actionsData,
                    AGSlotId: 1,
                    mode: 'ALLACTIONS',
                    SingleAction: '',
                    fileName: createActionState?.projectName,
                    isShowNewUI,
                }
            )
            // if (!status) {
            //     setShowDeviceConnectModal({
            //         isShow: true,
            //         text: `Invalid marker position! Each action's completion time must be between 100ms and 5000ms.`,
            //     })
            //     setDisplay('block')
            //     return
            // }

            // if (actionDetailsObj?.length <= 0) {
            if (createActionState.allActions.length <= 0) {
                setShowDeviceConnectModal({
                    isShow: true,
                    text: 'Please add at least one action before playing.',
                })
                setDisplay('block')
                return
            }

            let saveFlag = await extensionsFileSave(
                data,
                actionDetailsObj,
                waitTime
            )
            if (!saveFlag) {
                setShowDeviceConnectModal({
                    isShow: false,
                    text: '',
                })
                return
            }
            if (isplay) {
                await playActionFile(waitTime)
            } else {
                setShowDeviceConnectModal({
                    isShow: true,
                    text: 'Action saved successfully.',
                })
                setTimeout(
                    () =>
                        setShowDeviceConnectModal({ isShow: false, text: '' }),
                    2000
                )
            }
        } catch (e) {
            console.error(e)
        }
    }
    const handelSaveToBoard = () => {
        try {
            const actionsData = JSON.parse(
                sessionStorage.getItem('createActionState')
            )

            if (!webSerial.isConnected) {
                setShowDeviceConnectModal({
                    isShow: true,
                    text: 'Please connect the device.',
                })
                return
            }
            if (actionsData?.allActions?.length <= 0) {
                setShowDeviceConnectModal({
                    isShow: true,
                    text: 'Please add at least one action before saving.',
                })
                return
            }
            newuiGroupActionPlay(actionsData, false)
        } catch (e) {
            console.error(e)
        }
    }

    // Sends the action bytes of the entire action group
    const handlePlayActionGroup = async () => {
        if (!webSerial.isConnected) {
            setShowDeviceConnectModal({
                isShow: true,
                text: 'Please connect the device.',
            })
            return
        }
        if (isMotorTorqueEnable && isShowNewUI) {
            setShowDeviceConnectModal({
                isShow: true,
                text: 'Please toggle the motor button and enable it to play Actions.',
            })
            return
        }

        if (display !== 'none') {
            setDisplay('none')
            const actionsData = JSON.parse(
                sessionStorage.getItem('createActionState')
            )

            const { data, waitTime, status } = actionsToBytes({
                actionsData: actionsData,
                AGSlotId: 0,
                mode: 'ALLACTIONS',
                SingleAction: null,
                fileName: '',
                isShowNewUI,
            })

            // if (!status) {
            //     alert(
            //         'The action performance time can not less than 100 millisecond or more than 5000 millisecond.'
            //     )
            //     setDisplay('block')
            //     return
            // }
            // if (isAudioEnable && waveSurferRef?.current) {
            //     waveSurferRef.current.setTime(0)
            //     waveSurferRef.current.playPause()
            // }
            if (isShowNewUI) {
                // await newuiGroupActionPlay(actionsData)
                playPauseRef.current = true
                newuiGroupActionPlay1(actionsData)

                // return
            } else if (['1', '2', '3'].includes(deviceVersion[0])) {
                // sendDataAsPackets_zingV2(data, 42, webSerial.port)
                console.log('datas', data)
                worker.postMessage({
                    type: 'writeArray',
                    value: data,
                })
                // sessionStorage.setItem('sendDataAsPacket', 'true')
                sendDataRef.current = { sendDataAsPacket: true, readVal: '' }
                try {
                    let replyOK = await Promise.race([
                        checkOk(),
                        timeoutPromise(waitTime), //
                    ])
                    setDisplay('block')
                } catch (e) {
                    setDisplay('block')
                }
            } else {
                let size = 43
                // if (
                //     deviceVersion?.startsWith('1') &&
                //     ['Humanoid'].includes(connectedDevice)
                // ) {
                //     size = data.length
                // } else {
                //     size = 43
                // }
                if (await sendDataAsPackets(data, size, webSerial.port)) {
                    window.location.reload()
                }
            }
        } else {
            if (['1', '2', '3'].includes(deviceVersion[0])) {
                setDisplay('block')
                playPauseRef.current = false
                worker.postMessage({
                    type: 'writeArray',
                    value: ['R'.charCodeAt(0), 'a'.charCodeAt(0)],
                })

                // sessionStorage.setItem('sendDataAsPacket', 'true')
                sendDataRef.current = { sendDataAsPacket: true, readVal: '' }
                try {
                    let replyOK = await Promise.race([
                        checkOk(),
                        timeoutPromise(1000), //
                    ])
                } catch (e) {
                    setDisplay('block')
                    playPauseRef.current = false
                }
            }
        }
    }

    // This function splits the data into packets of custom size
    // and also sends them at the given interval
    const timeoutPromise = (ms) => {
        if (timeOutRef.current) {
            clearTimeout(timeOutRef.current)
            timeOutRef.current = null
        }
        return new Promise((resolve, reject) => {
            timeOutRef.current = setTimeout(() => {
                console.log('HHHHHHHHHH Time Out')
                timeOutRef.current = null
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    const checkOk = async () => {
        return new Promise(async (resolve, reject) => {
            while (true) {
                if (!sendDataRef?.current?.sendDataAsPacket) {
                    return resolve()
                }

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }
        })
    }

    const sendDataAsPackets = async (data, size, port) => {
        let count = 0
        let actionRowLength = JSON.parse(
            sessionStorage.getItem('createActionState')
        ).allActions.length
        while (data.length !== 0) {
            if (status) {
                let dataToBeSentNow
                // if (
                //     deviceVersion?.startsWith('1') &&
                //     ['Humanoid'].includes(connectedDevice) &&
                //     count === 0
                // ) {
                //     dataToBeSentNow = data.splice(0, 49)
                // } else if (
                //     deviceVersion?.startsWith('1') &&
                //     ['Humanoid'].includes(connectedDevice) &&
                //     count === actionRowLength - 1
                // ) {
                //     dataToBeSentNow = data.splice(0, 40)
                // } else {
                dataToBeSentNow = data.splice(0, size)
                // }

                sendBytes(dataToBeSentNow, port)
                count += 1
                status = false
                let replyOK
                try {
                    // const resultPromise = (replyOK = await readBytes(
                    //     port,
                    //     'OK'
                    // ))
                    try {
                        // if (sessionStorage.getItem('zingVersion')[0] == '2') {
                        replyOK = await Promise.race([
                            readBytes(port, 'OK'),
                            timeoutPromise(5000),
                        ])
                    } catch {
                        return true
                    }
                    console.log(replyOK, 'gsk replyOK')
                    if (replyOK == undefined) return true

                    if (replyOK) {
                        status = true
                    }
                } catch (error) {
                    console.log('errrr', error)
                    window.location.reload()
                }
            }
            if (
                count ===
                    JSON.parse(sessionStorage.getItem('createActionState'))
                        .allActions.length ||
                deviceVersion?.startsWith('1')
            ) {
                setDisplay('block')
                break
            }
        }
    }

    const clearActionFromSession = async () => {
        let newCreateActionState = JSON.parse(JSON.stringify(CREATEACTIONSTATE))
        if (isShowNewUI) {
            newCreateActionState.allActions = []
        }
        Object.keys(newCreateActionState.commonActionState).forEach((id) => {
            newCreateActionState.commonActionState[id].isSelected = false
            CREATEACTIONSTATE.commonActionState[id].isSelected = false
        })
        setAudioFile(null)
        setCreateActionState(newCreateActionState)
        sessionStorage.removeItem('createActionState')
        sessionStorage.removeItem('isShowNewUI')
        await clear()
    }

    const backButton = () => {
        let saved = JSON.parse(sessionStorage.getItem('isSave') || 'false')

        setSlideDirection(true)
        sessionStorage.setItem('slideDirection', true)
        if (!isShowNewUI) {
            saverecoveryData()
        }
        if (display == 'none') return

        // sending bytes to resume standby actions
        if (deviceVersion?.startsWith('0.1')) {
            worker.postMessage({
                type: 'writeArray',
                value: [
                    'S'.charCodeAt(0),
                    'A'.charCodeAt(0),
                    'S'.charCodeAt(0),
                ],
            })
        }

        if (isShowNewUI) {
            if (!saved) setShowErasModal(true)
            else {
                clearActionFromSession()
                const currMode = sessionStorage.getItem('programMode')
                if (currMode === 'flowchartBased') history.push('/flow')
                else history.push('/code/selectActionType')
                worker.postMessage({
                    type: 'writeArray',
                    value: ['R'.charCodeAt(0), 'a'.charCodeAt(0)],
                })
            }
        } else {
            history.push('/code/project/action/select')
        }
    }

    // Reorders the action buttons based on drag and drop
    function dragEndHandler({ source, destination }) {
        // dropped outside the list
        if (!destination) {
            return
        }

        // dropped on the SAME list
        const newCreateActionState = { ...createActionState }
        sessionStorage.setItem('isSave', JSON.stringify(false))
        const newList = newCreateActionState.allActions
        const [removed] = newList.splice(source.index, 1)
        newList.splice(destination.index, 0, removed)

        setCreateActionState(newCreateActionState)
        setSelectedAction(destination.index)
    }

    // its save the createActionState data in local storage
    const saverecoveryData = () => {
        let newRecoveryData =
            JSON.parse(
                localStorage.getItem('recoveryData') || JSON.stringify({})
            ) || {}
        let newCreateActionState = JSON.parse(
            sessionStorage.getItem('createActionState')
        )

        addData(
            'actionBase',
            connectedDevice,
            deviceVersion,
            newCreateActionState
        )

        localStorage.setItem('recoveryData', JSON.stringify(newRecoveryData))

        //create the recoveryData object
        function addData(baseType, connectedDevice, deviceVersion, data) {
            if (!newRecoveryData[baseType]) {
                newRecoveryData[baseType] = {}
            }
            if (!newRecoveryData[baseType][connectedDevice]) {
                newRecoveryData[baseType][connectedDevice] = {}
            }
            if (!newRecoveryData[baseType][connectedDevice][deviceVersion]) {
                newRecoveryData[baseType][connectedDevice][deviceVersion] = {}
            }
            newRecoveryData[baseType][connectedDevice][
                deviceVersion
            ].createActionState = data
        }
    }

    //send the bytes "SR0" to read the seral servo value
    const sendReadServoBytes = () => {
        //newCreateActionState.allActions[selectedAction]

        if (createActionState.allActions.length === 0) {
            setShowDeviceConnectModal({
                isShow: true,
                text: 'Please add at least one action.',
            })
            return
        }
        if (webSerial.isConnected) {
            setDisplay('none')
            worker.postMessage({
                type: 'fetchFileWriteArray',
                value: ['S'.charCodeAt(0), 'R'.charCodeAt(0), 0],
            })
            isNotReadRef.current = false
            setTimeout(() => setDisplay('block'), 3000)
        } else {
            setShowDeviceConnectModal({
                isShow: true,
                text: 'Please connect the device.',
            })
        }
    }

    //showing the popUp each servo sliders and all details
    const servoDetailsPopupOpen = (servoId, actionNumber) => {
        // time opens a dedicated popup with an input to edit it
        if (servoId === 'T') {
            setTimeEditPopUp({
                isShow: true,
                actionNumber: actionNumber,
            })
            return
        }

        setServoDetailsPopUpObj({
            isShowsServoDetailsPopUp: true,
            servoId: servoId,
            actionNumber: actionNumber,
        })
    }

    // const toggleSwipeBtnHandel = async () => {
    //     // if (createActionState?.allActions?.length > 0) {
    //     let newCreateActionState = JSON.parse(JSON.stringify(CREATEACTIONSTATE))
    //     newCreateActionState.allActions = []

    //     await clear()
    //     setAudioFile(null)
    //     setCreateActionState(newCreateActionState)
    //     setIsAudioEnablen(!isAudioEnable)
    //     // } else {
    //     //     setIsAudioEnablen(!isAudioEnable)
    //     // }
    // }

    //delete the data from recovery object
    function deleteRecoveryData(newRecoveryData, baseType, device, version) {
        if (newRecoveryData[baseType] && newRecoveryData[baseType][device]) {
            delete newRecoveryData[baseType][device][version]

            // If the device has no more versions, delete the device
            if (Object.keys(newRecoveryData[baseType][device]).length === 0) {
                delete newRecoveryData[baseType][device]
            }

            // If the baseType has no more devices, delete the baseType
            if (Object.keys(newRecoveryData[baseType]).length === 0) {
                delete newRecoveryData[baseType]
            }
        }
        localStorage.setItem('recoveryData', JSON.stringify(newRecoveryData))
    }

    const actionNameChange = (actionNumber, actionname) => {
        try {
            sessionStorage.setItem('isSave', JSON.stringify(false))
            let newCreateActionState = { ...createActionState }
            newCreateActionState.allActions[actionNumber].actionName =
                actionname
            setCreateActionState(newCreateActionState)
        } catch (e) {
            console.error(e)
        }
    }

    const genertHedertext = () => {
        if (isShowNewUI) {
            let name = createActionState?.projectName || 'Name'
            return { options: [name, '', ''], selected: 0 }
        } else if (['1', '2', '3'].includes(deviceVersion?.[0])) {
            return { options: ['Select', 'Create', ''], selected: 2 }
        } else {
            return { options: ['Select', 'Create', 'Save'], selected: 1 }
        }
    }
    const getShowShaveShow = () => {
        if (isShowNewUI) {
            return true
        } else if (isZingVersion12 || connectedDevice === 'Hexapod') {
            return false
        } else return true
    }

    //use the extensions and nativ application to save the mp3 file and action in the board
    const extensionsFileSave = async (
        actionBytes,
        actionDetailsObj,
        playTime
    ) => {
        try {
            let sdCardMountAt = device?.plodeNativeData?.mountPoint
            if (!sdCardMountAt) {
                sdCardMountAt = await getMountPoint({
                    socket: socketData.socket,
                })
                deviceMismatch({
                    ...device,
                    plodeNativeData: {
                        ...device.plodeNativeData,
                        mountPoint: sdCardMountAt,
                    },
                })
            }
            // sessionStorage.getItem('sdCardMountAt') || 'NO NAME'
            let deviceName = 'ZING'
            if (connectedDevice === 'Hexapod') deviceName = 'hexapod'

            let filePath = `${sdCardMountAt}/${deviceName}/actions/user`

            const chakingFlag = await checkFileExist({
                socket: socketData.socket,
                filePath,
                filename: createActionState?.projectName,
                isAudioFilePresent: audioFile,
            })

            if (!chakingFlag) {
                // setShowActionLoader(false)
                return false
            }

            if (audioFile) {
                const base64Data = audioFile.split(',')[1] // Data URL (Base64 encoded) than  Remove "data:*/*;base64," prefix

                let mp3SaveResponse = await writeFile({
                    socket: socketData.socket,
                    fileName: createActionState?.projectName,
                    fileFormat: 'mp3',
                    filePath: filePath,
                    fileData: base64Data,
                    writeTime: 120000,
                })

                if (mp3SaveResponse.success) {
                } else {
                    setShowDeviceConnectModal({
                        isShow: true,
                        text: `Something went wrong! Please try again.`,
                    })
                    setDisplay('block')
                    throw new Error('Something went wrong')
                }
            }
            const actionsUint8Array = new Uint8Array(actionBytes)
            const actionsDetailsUint8Array = new TextEncoder().encode(
                JSON.stringify(actionDetailsObj)
            )

            let actionWaitTime = calculateWaitTime(actionsUint8Array.length)

            // Encode to base64 string
            let actionsBase64Data = btoa(
                String.fromCharCode(...actionsUint8Array) +
                    String.fromCharCode(...actionsDetailsUint8Array)
            )

            //save  the bin file in board
            let binSaveResponse = await writeFile({
                socket: socketData.socket,
                fileName: createActionState?.projectName,
                fileFormat: 'bin',
                filePath: filePath,
                fileData: actionsBase64Data,
                writeTime: actionWaitTime,
            })

            if (binSaveResponse.success) {
                setShowDeviceConnectModal({
                    isShow: true,
                    text: `Action saved successfully. Now playing the action.`,
                })
            } else {
                setShowDeviceConnectModal({
                    isShow: true,
                    text: `Something went wrong! Please try again.`,
                })
                setDisplay('block')
                throw new Error('Something went wrong')
            }
            return true
        } catch (e) {
            setShowDeviceConnectModal({
                isShow: true,
                text: `Something went wrong! Please try again.`,
            })
            setDisplay('block')
            console.error(e)
            throw new Error('Something went wrong')
            // return true
        }
    }

    const playActionFile = async (playTime) => {
        try {
            await new Promise((reslove) => setTimeout(reslove, 2000))
            // setDisplay('block')
            let fLength = createActionState?.projectName.length
            let fNameAsci = createActionState?.projectName
                .split('')
                .map((char) => char.charCodeAt(0))

            let sendByte = [
                'P'.charCodeAt(0),
                'S'.charCodeAt(0),
                'A'.charCodeAt(0),
                fLength,
                ...fNameAsci,
                'E'.charCodeAt(0),
                'R'.charCodeAt(0),
            ]

            worker.postMessage({
                type: 'writeArray',
                value: sendByte,
            })
            // sessionStorage.setItem('sendDataAsPacket', 'true')
            sendDataRef.current = { sendDataAsPacket: true, readVal: '' }

            let replyOK = await Promise.race([
                checkOk(),
                timeoutPromise(playTime + 2000), //
            ])
            setShowDeviceConnectModal({
                isShow: false,
                text: ``,
            })
            setDisplay('block')
        } catch (e) {
            setShowDeviceConnectModal({
                isShow: true,
                text: `Something went wrong! Please try again.`,
            })
            setDisplay('block')
            console.log(e)
        }
    }

    //handel the swipe button
    const handelTorqueDisabelBtn = () => {
        setIsMotorTorqueEnable(!isMotorTorqueEnable)
        if (isMotorTorqueEnable) {
            isNotReadRef.current = true
            worker.postMessage({
                type: 'fetchFileWriteArray',
                value: ['S'.charCodeAt(0), 'R'.charCodeAt(0), 1],
            })
        } else {
            isNotReadRef.current = true
            worker.postMessage({
                type: 'fetchFileWriteArray',
                value: ['S'.charCodeAt(0), 'R'.charCodeAt(0), 0],
            })
        }
    }

    useEffect(() => {
        //read data from serial worker
        const messageHandler = (e) => {
            if (
                e.data.type === 'read' &&
                (e.data.value.includes('GROK') ||
                    e.data.value.includes('RDONE'))
            ) {
                // setDisplay('block')
                sendDataRef.current = { sendDataAsPacket: false, readVal: '' }
                if (sendDataWaitTimeRef) clearTimeout(sendDataWaitTimeRef)
            }
        }

        //if user close the window its save the createActionState data in local storage
        // const handleBeforeUnload11 = (event) => {
        //     // // if (!isShowNewUI)
        //     clearActionFromSession()
        // }

        const handleBeforeUnload = (e) => {
            // if (!isNavigating) {
            let saved = JSON.parse(sessionStorage.getItem('isSave') || 'false')
            if (!saved) {
                e.preventDefault()
                e.returnValue = '' // Required for Chrome
            }
        }

        const sendtorque0 = async () => {
            if (webSerial.isConnected) {
                setIsMotorTorqueEnable(true)
                isNotReadRef.current = true
                await new Promise((reslove, reject) => setTimeout(reslove, 200))
                worker.postMessage({
                    type: 'fetchFileWriteArray',
                    value: ['S'.charCodeAt(0), 'R'.charCodeAt(0), 0],
                })
            }
        }

        sendtorque0()

        worker.addEventListener('message', messageHandler)
        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            worker.removeEventListener('message', messageHandler)
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [isShowNewUI, webSerial.isConnected])
    useEffect(() => {
        //read data from serial worker
        const servoRead = (e) => {
            // let selectedAction1=0

            if (e.data.type === 'servoRead') {
                if (isNotReadRef.current) {
                    isNotReadRef.current = false
                    return
                }
                const newCreateActionState = { ...createActionState }
                for (let i = 0; i < e.data.value.length; i += 2) {
                    // if (
                    //     newCreateActionState.allActions[selectedAction].data[
                    //         (i + 2) / 2
                    //     ].isEnabled
                    // )
                    newCreateActionState.allActions[selectedAction].data[
                        (i + 2) / 2
                    ].value = (e.data.value[i + 1] << 8) | e.data.value[i]
                }
                setCreateActionState({ ...newCreateActionState })
                setDisplay('block')
            }
        }
        worker.addEventListener('message', servoRead)
        return () => worker.removeEventListener('message', servoRead)
    }, [createActionState, selectedAction])
    return (
        <div className={createStyle['create-Container']}>
            <SavePopUp
                showPopUp={filePopup}
                setFilePopUp={setFilePopUp}
                isShowNewUI={isShowNewUI}
                audioFile={audioFile}
                setAudioFile={setAudioFile}
                projectName={createActionState?.projectName}
            />

            {/*----- open the model to for enter the time when add the action ------*/}

            <DialogModal
                show={showTimeInputModal}
                text={
                    <div className={createStyle['addActionTimeInput']}>
                        <p>Enter the action playing time in milliseconds.</p>
                        <input ref={timeInputRef} type="number" />
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() => setShowTimeInputModal(false)}
                optionsToSelect={[
                    {
                        text: 'Enter',
                        do: () => {
                            handelSubmitTimeInput()
                        },
                    },
                ]}
            />
            {/*----- open the model to show to confrom the delete, use the react portal ------*/}
            <div ref={portalPopupRef}></div>
            {/*----- open the model to show if device is not connect ------*/}
            <DialogModal
                show={showDeviceConnectModal.isShow}
                text={showDeviceConnectModal.text}
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setShowDeviceConnectModal({ isShow: false, text: '' })
                }
            />
            {/* -------------------- open eras or not the create action data on back btn click ---------------------- */}
            <DialogModal
                show={showErasModal}
                text="All unsaved program will be erased. Are you sure want to continue ?"
                showCloseBtn={false}
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () => {
                            let newRecoveryData =
                                JSON.parse(
                                    localStorage.getItem('recoveryData') ||
                                        JSON.stringify({})
                                ) || {}
                            deleteRecoveryData(
                                newRecoveryData,
                                'actionBase',
                                connectedDevice,
                                deviceVersion
                            )

                            clearActionFromSession()

                            //when leave from create action panel send 'Ra' to come attention mood
                            worker.postMessage({
                                type: 'writeArray',
                                value: ['R'.charCodeAt(0), 'a'.charCodeAt(0)],
                            })

                            const currMode =
                                sessionStorage.getItem('programMode')
                            if (currMode === 'flowchartBased')
                                history.push('/flow')
                            else if (['2', '3'].includes(deviceVersion?.[0]))
                                history.push('/code/selectActionType')
                            else history.push('/code/project/')
                            // window.location.reload()
                        },
                    },
                    {
                        text: 'NO',
                        do: () => {
                            setShowErasModal(false)
                        },
                    },
                ]}
            />
            {/*----- open the model to show each servo details in read page ------*/}
            <ServoDetailsPopup
                createActionState={createActionState}
                servoDetailsPopUpObj={servoDetailsPopUpObj}
                setServoDetailsPopUpObj={setServoDetailsPopUpObj}
                handleMinMax={handleMinMax}
                handleSliderChange={handleSliderChange}
                handleSliderBtnClick={handleSliderBtnClick}
                selectedAction={selectedAction}
            />
            {/*----- popup to edit the action time ------*/}
            <TimeEditPopup
                timeEditPopUp={timeEditPopUp}
                setTimeEditPopUp={setTimeEditPopUp}
                createActionState={createActionState}
                handleActionDataChange={handleActionDataChange}
                getServoMinMax={getServoMinMax}
            />

            {/*----- open the model to show each servo point in device  ------*/}

            <DeviceMotorIdImg
                showDeviceModal={showDeviceModal}
                setShowDeviceModal={() => setShowDeviceModal(false)}
                showCloseBtn={true}
                DEVICEBUTTONS={DEVICEBUTTONS}
                inactiveBtnH={inactiveBtnH}
                inactiveBtnseventeen={inactiveBtnseventeen}
                inactiveBtneightteen={inactiveBtneightteen}
                isShowNewUI={isShowNewUI}
            />

            {/*----- open the model to show the fetch file from zing ------*/}
            <ViewActions
                viewPopUp={retrieveActions}
                setViewPopUp={setRetrieveActions}
                setCreateActionState={setCreateActionState}
                setSelectedAction={setSelectedAction}
                isShowNewUI={isShowNewUI}
                setAudioFile={setAudioFile}
            />
            <ProgramHeader
                // data={{
                //     options: [
                //         'Select',
                //         'Create',
                //         ...(isZingVersion12 || connectedDevice === 'Hexapod'
                //             ? ''
                //             : ['Save']),
                //         '',
                //     ],
                //     selected:
                //         isZingVersion12 || connectedDevice === 'Hexapod'
                //             ? 2
                //             : 1,
                // }}
                data={genertHedertext()}
                viewActions={
                    isZingVersion12 || connectedDevice === 'Hexapod'
                        ? true
                        : false
                }
                musicDisable={isShowNewUI}
                actionsList={setRetrieveActions}
                // toggleSwipeBtnHandel={toggleSwipeBtnHandel}
                // isAudioEnable={isAudioEnable}
                isShowNewUI={isShowNewUI}
                fileSaveClick={() => setFilePopUp(true)}
                showSave={getShowShaveShow()}
                handleSave={() => {
                    history.push('/code/project/action/save')
                }}
                showHelp={true}
                handleHelp={handleClickHelpBtn}
                isShowProjectName={true}
                projectName={createActionState?.projectName}
                setCreateActionState={setCreateActionState}
            />
            {/* call the help screen */}
            {showHelpScreen && (
                <ActionCreateHelp closeModal={closeHelpScreen} />
            )}
            {isShowNewUI && (
                <ActionCreateNew
                    regions={regions}
                    allActions={createActionState.allActions}
                    addNewAction={addNewAction}
                    deleteAction={deleteAction}
                    handleSelectAction={handleSelectAction}
                    selectedAction={selectedAction}
                    updateMarkerById={updateMarkerById}
                    handlePlayAction={handlePlayAction}
                    servoDetailsPopupOpen={servoDetailsPopupOpen}
                    display={display}
                    setDisplay={setDisplay}
                    // isAudioEnable={isAudioEnable}
                    tableBodyRef={tableBodyRef}
                    waveSurferRef={waveSurferRef}
                    setShowDeviceModal={() => setShowDeviceModal(true)}
                    actionNameChange={actionNameChange}
                    audioFile={audioFile}
                    setAudioFile={setAudioFile}
                    createActionState={createActionState}
                    setCreateActionState={setCreateActionState}
                    sendReadServoBytes={sendReadServoBytes}
                    portalPopupRef={portalPopupRef}
                    isMotorTorqueEnable={isMotorTorqueEnable}
                    setShowDeviceConnectModal={setShowDeviceConnectModal}
                />
            )}

            {!isShowNewUI && (
                <div
                    className={`${
                        slideDirection === 'true' ? 'slide-right' : 'slide-left'
                    }`}
                    style={{ height: '78vh' }}
                >
                    <div className={createStyle['create-body-container']}>
                        <div className={createStyle['action-sidebar']}>
                            <div
                                className={
                                    createStyle['action-sidebar-scrollZone']
                                }
                            >
                                <DragDropContext onDragEnd={dragEndHandler}>
                                    <Droppable droppableId="actionCol">
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                style={{
                                                    height: '100%',
                                                    overflowY: 'scroll',
                                                }}
                                            >
                                                {createActionState.allActions.map(
                                                    (action, index) => (
                                                        <Draggable
                                                            draggableId={
                                                                action.id
                                                            }
                                                            index={index}
                                                            key={action.id}
                                                        >
                                                            {(
                                                                provided,
                                                                snapshot
                                                            ) => (
                                                                <div
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    ref={
                                                                        provided.innerRef
                                                                    }
                                                                    id={`actionBtn-${
                                                                        index +
                                                                        1
                                                                    }`}
                                                                >
                                                                    <ActionButton
                                                                        selectedAction={
                                                                            selectedAction
                                                                        }
                                                                        hoverActionId={
                                                                            hoverActionId
                                                                        }
                                                                        showPrimaryButtons={
                                                                            showPrimaryButtons
                                                                        }
                                                                        index={
                                                                            index
                                                                        }
                                                                        action={
                                                                            action
                                                                        }
                                                                        handleSelectAction={
                                                                            handleSelectAction
                                                                        }
                                                                        handleToggleButtons={
                                                                            handleToggleButtons
                                                                        }
                                                                        deleteAction={
                                                                            deleteAction
                                                                        }
                                                                        copyAction={
                                                                            copyAction
                                                                        }
                                                                        handlePlayAction={
                                                                            handlePlayAction
                                                                        }
                                                                        display={
                                                                            display
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    )
                                                )}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </div>
                            <button
                                className={createStyle['addBtn']}
                                onClick={() => addNewAction({})}
                            >
                                {addIcon}
                            </button>
                        </div>

                        <div className={createStyle['action-card']}>
                            <>
                                <SliderBox
                                    key={'T'}
                                    id={'T'}
                                    btnText="Time"
                                    sliderText="milliseconds"
                                    value={
                                        createActionState.allActions[
                                            selectedAction
                                        ].data['T'].value
                                    }
                                    min={0}
                                    max={5000}
                                    handleSliderChange={handleSliderChange}
                                    handleClick={handleSliderBtnClick}
                                    isEnabled={
                                        createActionState.allActions[
                                            selectedAction
                                        ].data['T'].isEnabled
                                    }
                                    type="single"
                                />

                                {Object.entries(
                                    createActionState.allActions[selectedAction]
                                        .data
                                ).map((servoId) => (
                                    <>
                                        {isZingVersion12 &&
                                            createActionState.commonActionState[
                                                servoId[0]
                                            ].isSelected &&
                                            servoId[0] == 'H' && (
                                                <>
                                                    {/* {' '}
                                                <SliderBox
                                                    key={servoId[0]}
                                                    id={`${servoId[0]}speed`}
                                                    btnText={`Head Speed`}
                                                    sliderText="Value"
                                                    value={
                                                        createActionState
                                                            .allActions[
                                                            selectedAction
                                                        ].data[servoId[0]].speed
                                                    }
                                                    min={0}
                                                    max={50}
                                                    handleSliderChange={
                                                        handleSliderChange
                                                    }
                                                    handleClick={
                                                        handleSliderBtnClick
                                                    }
                                                    isEnabled={
                                                        createActionState
                                                            .allActions[
                                                            selectedAction
                                                        ].data[servoId[0]]
                                                            .isEnabled
                                                    }
                                                    type="single"
                                                />{' '} */}
                                                    <SliderBox
                                                        isDisabledAction={
                                                            display !== 'block'
                                                        }
                                                        key={servoId[0]}
                                                        id={`${servoId[0]}servo`}
                                                        btnText={`Head Servo`}
                                                        sliderText="Value"
                                                        value={
                                                            createActionState
                                                                .allActions[
                                                                selectedAction
                                                            ].data[servoId[0]]
                                                                .value
                                                        }
                                                        min={0}
                                                        max={180}
                                                        handleSliderChange={
                                                            handleSliderChange
                                                        }
                                                        handleClick={
                                                            handleSliderBtnClick
                                                        }
                                                        isEnabled={
                                                            createActionState
                                                                .allActions[
                                                                selectedAction
                                                            ].data[servoId[0]]
                                                                .isEnabled
                                                        }
                                                        type="single"
                                                    />
                                                </>
                                            )}
                                        {createActionState.commonActionState[
                                            servoId[0]
                                        ].isSelected &&
                                            servoId[0] !== 'T' &&
                                            servoId[0] !== 'H' && (
                                                <SliderBox
                                                    isDisabledAction={
                                                        display !== 'block'
                                                    }
                                                    // isDisabledAction={true}
                                                    key={servoId[0]}
                                                    id={servoId[0]}
                                                    btnText={`Servo Motor ${servoId[0]}`}
                                                    sliderText="Value"
                                                    value={
                                                        createActionState
                                                            .allActions[
                                                            selectedAction
                                                        ].data[servoId[0]].value
                                                    }
                                                    min={
                                                        connectedDevice ===
                                                        'Hexapod'
                                                            ? handleMinMax(
                                                                  servoId[0],
                                                                  'MIN',
                                                                  'HEXAPOD'
                                                              )
                                                            : isZingVersion12
                                                            ? handleMinMax(
                                                                  servoId[0],
                                                                  'MIN',
                                                                  'ZING'
                                                              )
                                                            : 0
                                                    }
                                                    max={
                                                        connectedDevice ===
                                                        'Hexapod'
                                                            ? handleMinMax(
                                                                  servoId[0],
                                                                  'MAX',
                                                                  'HEXAPOD'
                                                              )
                                                            : isZingVersion12
                                                            ? handleMinMax(
                                                                  servoId[0],
                                                                  'MAX',
                                                                  'ZING'
                                                              )
                                                            : 1000
                                                    }
                                                    handleSliderChange={
                                                        handleSliderChange
                                                    }
                                                    handleClick={
                                                        handleSliderBtnClick
                                                    }
                                                    isEnabled={
                                                        createActionState
                                                            .allActions[
                                                            selectedAction
                                                        ].data[servoId[0]]
                                                            .isEnabled
                                                    }
                                                    type="single"
                                                />
                                            )}
                                    </>
                                ))}
                            </>
                        </div>

                        <div
                            className={
                                createStyle[
                                    `create-${connectedDevice.toLowerCase()}`
                                ]
                            }
                            style={{
                                backgroundImage: `url(${
                                    IMAGE[connectedDevice.toUpperCase()]
                                })`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                            }}
                        >
                            {DEVICEBUTTONS[`${connectedDevice.toUpperCase()}`]}
                            {/* no clue */}
                            {isZingVersion12 && (
                                <img
                                    className={`${
                                        createStyle['sc-toggle-button']
                                    } ${
                                        createStyle[`sc-btn-H-${isShowNewUI}`]
                                    }`}
                                    src={
                                        createActionState?.commonActionState?.[
                                            'H'
                                        ]?.isSelected
                                            ? activeBtnH
                                            : inactiveBtnH
                                    }
                                />
                            )}
                            {connectedDevice === 'Hexapod' && (
                                <>
                                    <img
                                        className={`${
                                            createStyle['sc-toggle-button']
                                        } ${
                                            createStyle[
                                                `sc-btn-${connectedDevice.toLowerCase()}-seventeen-${isShowNewUI}`
                                            ]
                                        }`}
                                        src={
                                            createActionState
                                                ?.commonActionState?.[17]
                                                ?.isSelected
                                                ? activeBtnseventeen
                                                : inactiveBtnseventeen
                                        }
                                    />
                                    <img
                                        className={`${
                                            createStyle['sc-toggle-button']
                                        } ${
                                            createStyle[
                                                `sc-btn-${connectedDevice.toLowerCase()}-eighteen-${isShowNewUI}`
                                            ]
                                        }`}
                                        src={
                                            createActionState
                                                ?.commonActionState?.[18]
                                                ?.isSelected
                                                ? activeBtneightteen
                                                : inactiveBtneightteen
                                        }
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {/* showActionLoader */}

            <div
                className={createStyle['createActionFooter']}
                // style={{ height: '10vh' }}
            >
                <div
                    className={createStyle['footerLeft']}
                    // style={{ border: '1px solid red' }}
                >
                    <div className={createStyle['create-backbuttonDiv']}>
                        <img
                            className={createStyle['create-backbutton']}
                            style={{
                                cursor:
                                    display == 'none'
                                        ? 'not-allowed'
                                        : 'pointer',
                            }}
                            src={backbutton}
                            onClick={backButton}
                        />
                    </div>
                    {isShowNewUI && (
                        <div className={createStyle['torqueSwitchDivParent']}>
                            <div className={createStyle['torqueSwitchDiv']}>
                                <p className={createStyle['torqueSwitcLabel']}>
                                    Motors
                                </p>
                                <label className={createStyle['torqueSwitch']}>
                                    <input
                                        className={
                                            createStyle['torqueCheckbox']
                                        }
                                        type="checkbox"
                                        // value={!isMotorTorqueEnable}
                                        checked={!isMotorTorqueEnable}
                                        onChange={(e) =>
                                            handelTorqueDisabelBtn()
                                        }
                                    />
                                    <span
                                        className={createStyle['torqueSlider']}
                                    ></span>
                                </label>
                            </div>
                            <p
                                className={`${createStyle.tooltip} ${createStyle.torqueBtnTooltip}`}
                                style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                Enable/Disable motor torque
                            </p>
                        </div>
                    )}
                </div>
                <div
                    className={createStyle['footerMeddle']}
                    style={{ width: '53.3vw' }}
                >
                    {isShowNewUI && (
                        <div className={createStyle['addBtnDiv']}>
                            <img
                                className={createStyle['newAddBtn']}
                                src={renderImage('buttonPlusImg')}
                                draggable="false"
                                alt="add"
                                style={{}}
                                onClick={(e) => setShowTimeInputModal(true)} //addNewAction({})
                            />
                            <p
                                className={`${createStyle.tooltip} ${createStyle.newAddBtnTooltip}`}
                                style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '-19%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                Add action
                            </p>
                        </div>
                    )}
                </div>

                <div className={createStyle['footerRight']}>
                    <div className={createStyle['create-playgroupDiv']}>
                        <img
                            className={createStyle['create-playgroup']}
                            style={{
                                pointerEvents:
                                    display == 'none' &&
                                    !['1', '2', '3'].includes(deviceVersion[0])
                                        ? 'none'
                                        : 'auto',
                                opacity:
                                    display == 'none' &&
                                    !['1', '2', '3'].includes(deviceVersion[0])
                                        ? '0.5'
                                        : '1',
                            }}
                            src={
                                display == 'none' &&
                                ['1', '2', '3'].includes(deviceVersion[0])
                                    ? renderPrgImage('pauseBtn')
                                    : renderPrgImage('playrunBtn')
                            } //
                            onClick={handlePlayActionGroup}
                        />
                        <p
                            className={`${createStyle.tooltip} ${createStyle.groupPlaydbtn}`}
                            style={{
                                position: 'absolute',
                                right: '-11vh',
                                top: '-38%',
                                width: '16vh',
                                transform: 'translate(-50%, -50%)',
                            }}
                        >
                            play actions group
                        </p>
                    </div>
                    <div className={createStyle['create-nextbuttonDiv']}>
                        <img
                            className={createStyle['create-nextbutton']}
                            style={{
                                // bottom:
                                //     isZingVersion12 || connectedDevice === 'Hexapod'
                                //         ? '3%'
                                //         : null,
                                cursor:
                                    display == 'none'
                                        ? 'not-allowed'
                                        : 'pointer',
                            }}
                            src={
                                isShowNewUI
                                    ? renderPrgImage('uploadBtn')
                                    : isZingVersion12 ||
                                      connectedDevice === 'Hexapod'
                                    ? renderPrgImage('saveBtn')
                                    : nextbutton
                            }
                            onClick={() => {
                                setSlideDirection(false)
                                sessionStorage.setItem('slideDirection', false)
                                if (display == 'none') return
                                if (isShowNewUI) {
                                    handelSaveToBoard()
                                } else if (
                                    isZingVersion12 ||
                                    connectedDevice === 'Hexapod'
                                ) {
                                    setFilePopUp(true)
                                } else {
                                    history.push('/code/project/action/upload')
                                }
                            }}
                        />
                        <p
                            className={`${createStyle.tooltip} ${createStyle.savbtn}`}
                            style={{
                                position: 'absolute',
                                right: '-11vh',
                                top: '-38%',
                                width: '16vh',
                                transform: 'translate(-50%, -50%)',
                                //createStyle['tooltip']
                            }}
                        >
                            Save action
                        </p>
                    </div>

                    {/* {deviceVersion.startsWith('2') && isShowNewUI && (
                    <img
                        className={createStyle['create-upload']}
                        style={{
                            cursor:
                                display == 'none' ? 'not-allowed' : 'pointer',
                            opacity: display == 'none' ? '0.5' : '1',
                        }}
                        src={renderPrgImage('uploadBtn')}
                        onClick={() => {
                            sendReadServoBytes()
                        }}
                    />
                )} */}
                    {/* <span
                    className={`${createStyle.tooltip} ${createStyle.readbtn}`}
                    style={{ position: 'absolute', right: '11%', bottom: '9%' }}
                >
                    Read servo
                </span> */}
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        deviceMismatch: (data) => {
            dispatch({ type: 'DEVICE_MISMATCH', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateAction)
